import React, { useState, useRef, useEffect } from "react";

interface CustomToneOfVoiceProps {
  setInstruction: (value: string) => void;
  setCustomName: (value: string) => void;
  initialName: string;
  initialInstruction: string;
  tovFormMode: string;
  setExceedsWordLimit: (value: boolean) => void;
}

const CustomToneOfVoice = ({
  setInstruction,
  setCustomName,
  initialName,
  initialInstruction,
  tovFormMode,
  setExceedsWordLimit,
}: CustomToneOfVoiceProps) => {
  const [name, setName] = useState(initialName);
  const [instructionText, setInstructionText] = useState(initialInstruction);
  const inputRef = useRef<HTMLInputElement | null>(null);

  const MAX_WORDS = 250;

  const countWords = (text: string) => {
    return text
      .trim()
      .split(/\s+/)
      .filter((word) => word.length > 0).length;
  };
  const currentWordCount = countWords(instructionText);

  const getCounterClass = () => {
    if (currentWordCount > 250) return "text-danger";
    return "text-primary-custom";
  };

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setName(e.target.value);
    setCustomName(e.target.value.trim());
  };

  const handleInstructionChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newValue = e.target.value;
    const newWordCount = countWords(newValue);

    if (newWordCount > 250) {
      setExceedsWordLimit(true);
    } else {
      setExceedsWordLimit(false);
    }

    setInstructionText(newValue);
    setInstruction(newValue);
  };

  return (
    <div className="tov-container">
      <div className="tov-title">
        {tovFormMode == "add" ? "Add New Tone of Voice" : "Edit Tone Of Voice"}
      </div>

      <div className="tov-input-wrapper">
        <label className="tov-sub-title" htmlFor="tov-input">
          Name*
        </label>
        <input
          id="tov-input"
          ref={inputRef}
          type="text"
          value={name}
          onChange={handleInputChange}
          className="tov-input"
          placeholder="e.g. Professional, Friendly, Persuasive..."
          maxLength={100}
          aria-required="true"
        />
      </div>

      <div>
        <div className="tov-sub-title">Instructions*</div>
        <label className="instruction-info">
          Describe how the assistant should write - tone, vocabulary, style, and any specific rules.
        </label>
      </div>

      <div className="tov-textarea-wrapper">
        <textarea
          className="text-area"
          placeholder="e.g. Use formal language, avoid contractions, keep sentences concise..."
          value={instructionText}
          onChange={handleInstructionChange}
        />
        <div className={`word-counter ${getCounterClass()}`}>
          {currentWordCount}/{MAX_WORDS}
        </div>
      </div>
    </div>
  );
};

export default CustomToneOfVoice;
